<mat-drawer-container>
  <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="true" #matDrawer>
    <router-outlet></router-outlet>
  </mat-drawer>
  <mat-drawer-content class="h-auto">
    <div class="content">
      <!-- Header -->
      <div class="header">
        <!-- Title -->
        <ng-container *ngIf="folder">
          <div class="title">
            <folders-breadcrumbs [path]="folder.path"></folders-breadcrumbs>
            <h1 data-cy="folder-name">{{ folder.name }}</h1>
          </div>
        </ng-container>

        <!-- Main actions -->
        <div class="main-actions">
          <div class="search">
            <mat-form-field class="treo-mat-dense treo-mat-no-subscript">
              <mat-icon matPrefix [svgIcon]="'search'"></mat-icon>
              <input
                data-cy="search-input"
                matInput
                [formControl]="searchInputControl"
                [matAutocomplete]="matAutocomplete"
                [placeholder]="'Search...'"
              />
            </mat-form-field>

            <mat-autocomplete
              [class]="'search-results search-results-appearance-basic'"
              #matAutocomplete="matAutocomplete"
              [disableRipple]="true"
            >
              <mat-option
                class="no-results"
                *ngIf="results && !results.file_resources.length && !results.folder_resources.length"
              >
                No results found!
              </mat-option>
              <mat-option *ngFor="let result of results.file_resources" data-cy="search-result-item">
                <div class="result contact-result flex flex-row" (click)="viewFile(result)">
                  <div><mat-icon [svgIcon]="'description'"></mat-icon></div>
                  <div class="title">
                    <span [innerHTML]="result.name"></span>
                  </div>
                </div>
              </mat-option>

              <mat-option *ngFor="let result of results.folder_resources" data-cy="search-result-item">
                <div class="result contact-result flex flex-row" (click)="navigateToFolder(result)">
                  <div><mat-icon [svgIcon]="'folder'"></mat-icon></div>
                  <div class="title">
                    <span [innerHTML]="result.name"></span>
                  </div>
                </div>
              </mat-option>
            </mat-autocomplete>
          </div>
          <!-- Add task button -->
          <button
            class="add-task"
            mat-flat-button
            [color]="'primary'"
            (click)="fileInput.click()"
            [matTooltip]="'Shortcut: Ctrl + /'"
            data-cy="properties-upload-file-button"
          >
            <mat-icon [svgIcon]="'add'"></mat-icon>
            <input
              data-cy="upload-file-input"
              style="display: none"
              type="file"
              (change)="onFileChanged($event, folder.id)"
              #fileInput
            />
            Upload File
          </button>

          <!-- Add section button -->
          <button
            class="add-section"
            data-cy="create-folder-button"
            mat-flat-button
            [color]="'accent'"
            (click)="createFolder(folder.id)"
            [matTooltip]="'Shortcut: Ctrl + .'"
          >
            <mat-icon [svgIcon]="'add'"></mat-icon>
            Create Folder
          </button>
        </div>
        <div class="loader" *ngIf="loading">
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </div>
      </div>

      <div class="tasks-list">
        <ng-container *ngIf="childFolders && childFolders.length > 0">
          <div
            [id]="'task-' + childFolder.id"
            class="task"
            *ngFor="let childFolder of childFolders; trackBy: trackByFn"
            [ngClass]="'type-section'"
            draggable="true"
            (dragstart)="handleDragStart($event, childFolder)"
            (dragover)="handleDragOver($event, childFolder)"
            (dragleave)="handleDragLeave($event)"
            (drop)="handleDrop($event, childFolder)"
            (dragend)="handleDragEnd($event)"
          >
            <!-- Task content -->
            <div class="task-content">
              <!-- Drag handle -->
              <div class="drag-handle" cdkDragHandle>
                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
              </div>

              <!-- Task link -->
              <a class="pointer">
                <div class="title">
                  <div (click)="navigateToFolder(childFolder)">
                    <span data-cy="file-list-item-name" *ngIf="childFolder.name">{{ childFolder.name }}</span>
                  </div>
                </div>

                <div class="due-date mr-2">
                  {{ childFolder.file_size | filesize }}
                </div>
                <div class="due-date">
                  {{ childFolder.num_files }}
                  <ng-container *ngIf="childFolder.num_files === 1"> file </ng-container>
                  <ng-container *ngIf="childFolder.num_files !== 1"> files </ng-container>
                </div>
                <div class="due-date">
                  <button
                    class="more-menu"
                    mat-icon-button
                    [matMenuTriggerFor]="moreMenu"
                    data-cy="file-list-item-actions"
                  >
                    <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                  </button>

                  <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item (click)="editFolderResource(childFolder)">
                      <mat-icon [svgIcon]="'edit'"></mat-icon>
                      <span>Rename</span>
                    </button>
                    <button mat-menu-item (click)="shareFolderResource(childFolder.id)">
                      <mat-icon [svgIcon]="'share'"></mat-icon>
                      <span>Share</span>
                    </button>
                    <button mat-menu-item (click)="deleteFolder(childFolder.id)" data-cy="button-delete-folder">
                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </a>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="files && files.length > 0">
          <!-- Files -->
          <div
            [id]="'task-' + file.id"
            class="task"
            *ngFor="let file of files; trackBy: trackByFn"
            [ngClass]="'type-task'"
            draggable="true"
            (dragstart)="handleDragStart($event, file)"
            (dragover)="handleDragOver($event, file)"
            (dragleave)="handleDragLeave($event)"
            (drop)="handleDrop($event, file)"
            (dragend)="handleDragEnd($event)"
          >
            <!-- Task content -->
            <div class="task-content">
              <!-- Drag handle -->
              <div class="drag-handle" cdkDragHandle>
                <mat-icon [svgIcon]="'drag_indicator'"></mat-icon>
              </div>

              <!-- Task link -->
              <a class="pointer">
                <div class="title">
                  <div (click)="viewFile(file)" class="pointer">
                    <span data-cy="file-list-item-name" *ngIf="file.name">{{ file.name }}</span>
                  </div>
                </div>
                <div class="due-date mr-10" *ngIf="file.related_to_type && file.related_to_type !== 'Project'">
                  {{ file.related_to_type }}: {{ file.related_to_name }}
                </div>
                <div class="due-date mr-10">
                  {{ file.file_size | filesize }}
                </div>
                <div class="due-date mr-10">
                  {{ file.user?.full_name }}
                </div>
                <div class="due-date mr-10">
                  {{ file.updated_at | date: 'LLL dd, y h:mm a' }}
                </div>
                <div class="due-date">
                  <button
                    class="more-menu"
                    mat-icon-button
                    [matMenuTriggerFor]="moreMenu"
                    data-cy="file-list-item-actions"
                  >
                    <mat-icon [svgIcon]="'more_vert'"></mat-icon>
                  </button>

                  <mat-menu #moreMenu="matMenu">
                    <button mat-menu-item (click)="renameFile(file)" data-cy="button-rename-file">
                      <mat-icon [svgIcon]="'edit'"></mat-icon>
                      <span>Rename</span>
                    </button>
                    <button mat-menu-item (click)="downloadFile(file)">
                      <mat-icon [svgIcon]="'get_app'"></mat-icon>
                      <span>Download</span>
                    </button>
                    <button mat-menu-item (click)="shareFileResource(file)" data-cy="button-share-file">
                      <mat-icon [svgIcon]="'share'"></mat-icon>
                      <span>Share</span>
                    </button>
                    <button
                      mat-menu-item
                      (click)="sendToDocusign(file)"
                      *ngIf="account && (account.subdomain === 'msc' || account.subdomain === 'crb')"
                    >
                      <mat-icon [svgIcon]="'menu_book'"></mat-icon>
                      <span>Send to Docusign</span>
                    </button>
                    <button mat-menu-item (click)="deleteFile(file.id)" data-cy="button-delete-file">
                      <mat-icon [svgIcon]="'delete'"></mat-icon>
                      <span>Delete</span>
                    </button>
                  </mat-menu>
                </div>
              </a>
            </div>
          </div>
        </ng-container>

        <ngx-file-drop (onFileDrop)="onFileDropped($event, folder.id)" customstyle="" customContentStyle="">
          <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <div class="no-tasks pt-10">
              <mat-icon [svgIcon]="'iconsmind:bulleted_list'"></mat-icon>
              <h4>Drag and drop a file.</h4>
            </div>
          </ng-template>
        </ngx-file-drop>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
<span #emptyItem></span>
